import React, { useState, useEffect } from "react";
import '../../css/trust.css';
import { formatPhoneNumber } from '../../utilities/dashFunction.js';
import { deleteService, deleteServiceNumber } from '../../utilities/trustHubFunctions.js';
import { useSelector } from 'react-redux';
import Icon from "../../assets/icons/icon.js";
import { useDispatch } from "react-redux";
import { setTextNumbers } from "../../features/agentSlice.js";
import { fetchWithDefaults } from "../../config/fetchDefault.js";

function MessagingService({ data, fetchServices, setNumberChoice, serviceInfo, formatString, setNewCampaign, newService, brandInfo }) {
    const agentId = useSelector((state) => state.agent.userData).agentId;
    const serviceInUse = false;
    const [services, setServices] = useState(false);

    const dispatch = useDispatch()

    useEffect(() => {
        if (serviceInfo.length > 0) {
            setServices(serviceInfo);
        }
    }, [serviceInfo]);
    useEffect(() => {
        fetchServices()
    }, [newService])
    const removeService = (camp, service) => {
        if (camp === 'VERIFIED') {
            // needs to be refactored to use a modal
            // alert is not being used anywhere else in the app
            alert("Can't Delete");
        }
        else {
            deleteService(service, agentId, setServices);
        }
    }
    const handleRemoveFromService= async (numberSid, messageSid)=>{
        try {
            await deleteServiceNumber(messageSid, agentId, numberSid, services, setServices)
            // Refresh the parent serviceInfo state to ensure addNumbersToService.js gets updated data
            fetchServices();
            // update texting numbers portion of agent slice with updated texting number options
            const response = await fetchWithDefaults(`/twilioToken?agent=${agentId}`)

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const [twilioData] = await response.json()
            dispatch(setTextNumbers(twilioData.textingNumbers))
        } catch (error) {
            console.error('Error deleting number from service:', error);
        }
    }

    return (
        <div className="mainBlockWrapper twoX">
            <div className="mainBlockHeader">
                <div className="mainBlockTitle">Messaging Campaign</div>
            </div>

            <div className="mainBlockContent">
                {services && services.map((item, index) => (
                    item.sid !== serviceInUse ? (
                        <div key={`services${index}`} className={`bigBlock a2p${item.status} ${item.sid === serviceInUse ? 'inUse' : ''}`} style={{marginTop: '25px'}}>
                            <div className="quilityCloseWindow oulineQuilityDestructiveButton" onClick={()=>removeService(item.status, item.sid)}><span className="fontello" style={{marginTop: '-7px'}}><Icon name={'x-circle-q'} size={34} className="closeIcon" adjust="fontello" /></span></div>
                            <div className="leadCardBlock">
                                <div className="innerWrapper">
                                    <div className="leadInfoLine">
                                        <span className="dataFieldTitle">Name: </span>
                                        <span className="leadData">{item.name}</span>
                                    </div>
                                    <div className="leadInfoLine" style={{ backgroundColor: item.status != null ? '' : 'var(--quility-button-color)' }}>
                                        <span className="dataFieldTitle">Status: </span>
                                        <span className="leadData">{item.status != null ? formatString(item.status) : <span onClick={() => setNewCampaign(item.sid)} style={{ cursor: 'pointer' }}>Click To Attach Campaign</span>}</span>
                                    </div>
                                    <div className="leadInfoLine">
                                        <span className="dataFieldTitle">Use Case: </span>
                                        <span className="leadData">{item.use_case != null ? formatString(item.use_case) : "No Use Case"}</span>
                                    </div>
                                    <div className="leadInfoLine">
                                        <span className="dataFieldTitle">Numbers: </span>
                                        <span className="leadData" style={{ textDecoration: 'none' }}>
                                            <>
                                                <div className="addNumberButton" onClick={() => setNumberChoice({ type: item.name.includes('LOW_VOLUME') ? 'STANDARD' : 'sole', service: item.sid })}>+ Add Numbers</div>
                                                {item.phoneNumbers.map((number, index) => {
                                                    const isSoleProprietor = brandInfo && brandInfo[0]?.brandType === "SOLE_PROPRIETOR";
                                                    return (
                                                        <div key={`add_number_to_service_${index}`} className="serviceNumber">
                                                            {formatPhoneNumber(number.phoneNumber)} 
                                                            {!isSoleProprietor && (
                                                                <span className="smallQuilityRemove oulineQuilityDestructiveButton" onClick={() => handleRemoveFromService(number.sid, item.sid)}>
                                                                    <span className="fontello" style={{ marginTop: '-7px' }}>
                                                                        <Icon name={'x-circle-q'} size={20} className="closeIcon" adjust="fontello" />
                                                                    </span>
                                                                </span>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </>
                                        </span>
                                    </div>
                                    <div className="leadInfoLine">
                                        <span className="dataFieldTitle">In-Use: </span>
                                        {/* Is the 'Make Default' option needed here? All it does is trigger an alert that says HI. */}
                                        <span className="leadData" >{item.sid === data[0].soleBrand || item.sid === data[0].hubBrand ? 'Active' : <div className="quilitySmallInlineButton" style={{ display: 'inline-block', height: '25px', lineHeight: '25px' }} onClick={() => alert("HI")}>Make Default</div>}</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    ) : (
                        null
                    )

                ))}
            </div>
            <div className="blockFooter">
                <div
                    className="buttonWrapper"
                    style={{ marginLeft: "10px" }}
                >
                    <div className="dataButtonBlock">Services: {services.length}</div>
                    <div className="actionButtonBlock" style={{ marginTop: '5px' }}>
                        <div className="accentButton solidQuilityActiveButton" onClick={() => setNewCampaign(true)}>
                            +  New Campaign
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default MessagingService;

/*<div className="leadInfoLine">
                                        <span className="dataFieldTitle">In-Use: </span>
                                        <span className="leadData" >{item.sid === data[0].soleBrand || item.sid === data[0].hubBrand ? 'Active' : <div className="quilitySmallInlineButton" style={{display: 'inline-block',height: '25px',lineHeight: '25px'}}>Make Default</div>}</span>
                                    </div>*/
